<script>
	import {
		Dropdown,
		DropdownMenu,
		DropdownToggle,
	} from "@sveltestrap/sveltestrap";
</script>

<Dropdown>
	<DropdownToggle tag="div">
		<div class="table-dropdown">
			<img src="/assets/icon-dots-vertical.svg" alt="icon-dots" />
		</div>
	</DropdownToggle>
	<DropdownMenu>
		<slot />
	</DropdownMenu>
</Dropdown>
